const scrollPrecentage = () => {
  const postContentElement = document.querySelector('.single-post-page-content');
  const postTopContentElement = document.querySelector('.single-post-page-general-info');

  const scrollProgressElement = document.querySelector('#progress');
  const progressValueElement = document.querySelector('#progress-value');

  const mobileScrollProgressElement = document.querySelector('#mobile-progress');
  const mobileProgressValueElement = document.querySelector('#mobile-progress-value');
  const mobileProgressSubstrateElement = document.querySelector('#mobile-progress-substrate');
  const mobileProgressTextElement = document.querySelector('#mobile-progress-text');

  const progressBackgroundColor = '#008BB7';
  const progresTrackColor = '#D9D9D9';
  const MIN_PROGRESS_VALUE = 0;
  const MAX_PROGRESS_VALUE = 100;
  const headerHeight = 100;
  const invisibleClass = 'progress-invisible';

  if (!postContentElement || !postTopContentElement) {
    return;
  }

  const contentElementHeight = postContentElement.scrollHeight;
  const scrollPosition = document.documentElement.scrollTop - (postTopContentElement.offsetTop + headerHeight);
  const scrollValue = Math.round((scrollPosition * MAX_PROGRESS_VALUE) / contentElementHeight);
  const validScrollValue = scrollValue <= MAX_PROGRESS_VALUE && scrollValue >= MIN_PROGRESS_VALUE ? scrollValue : scrollValue < MIN_PROGRESS_VALUE ? MIN_PROGRESS_VALUE : MAX_PROGRESS_VALUE;
  const mobileProgressContent = `${validScrollValue}% прочитано`;

  if (scrollValue > MAX_PROGRESS_VALUE) {
    scrollProgressElement?.classList.add(invisibleClass);
    mobileScrollProgressElement?.classList.add(invisibleClass);
  } else {
    scrollProgressElement?.classList.remove(invisibleClass);
    mobileScrollProgressElement?.classList.remove(invisibleClass);
  }

  if (scrollProgressElement && progressValueElement) {
    scrollProgressElement.style.background = `conic-gradient(${progressBackgroundColor} ${validScrollValue}%, ${progresTrackColor} ${validScrollValue}% )`;
    progressValueElement.textContent = `${validScrollValue}%`;
  }

  if (mobileProgressTextElement && mobileProgressValueElement && mobileProgressSubstrateElement) {
    mobileProgressTextElement.textContent = mobileProgressContent;
    mobileProgressValueElement.style.width = `${validScrollValue}%`;
    mobileProgressSubstrateElement.textContent = mobileProgressContent;
  }
}